// Payments Module - Phase 1 MVP
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Receipt, CreditCard, ScanText } from "lucide-react";

export const PaymentsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex-1 space-y-4 p-4 md:p-6 pt-6">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">Payments</h2>
        <p className="text-muted-foreground">
          Manage customer receipts and payment allocations
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Card className="cursor-pointer hover:shadow-lg transition-shadow" onClick={() => navigate("/payments/receipts")}>
          <CardHeader>
            <div className="flex items-center gap-2">
              <Receipt className="h-5 w-5 text-primary" />
              <CardTitle>Receipts</CardTitle>
            </div>
            <CardDescription>
              View and allocate customer receipts
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button className="w-full">
              Go to Receipts
            </Button>
          </CardContent>
        </Card>

        <Card className="opacity-50">
          <CardHeader>
            <div className="flex items-center gap-2">
              <CreditCard className="h-5 w-5 text-muted-foreground" />
              <CardTitle>Direct Debits</CardTitle>
            </div>
            <CardDescription>
              Manage direct debit payments
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button className="w-full" variant="outline" disabled>
              Coming Soon
            </Button>
          </CardContent>
        </Card>

        <Card className="opacity-50">
          <CardHeader>
            <div className="flex items-center gap-2">
              <ScanText className="h-5 w-5 text-muted-foreground" />
              <CardTitle>OCR Remittance</CardTitle>
            </div>
            <CardDescription>
              Upload PDF remittances for automatic invoice matching
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button className="w-full" variant="outline" disabled>
              Coming Soon
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

// Export new pages
export { default as ReceiptsDashboard } from './receipts-dashboard';
export { default as AllocationWorkspace } from './allocation-workspace';

// Export Phase 2 components
export { AutoAllocateDropdown } from './auto-allocate-dropdown';
export { AutoAllocatePreviewModal } from './auto-allocate-preview-modal';
export { PromiseAlertBanner } from './promise-alert-banner';
export { PromiseTransactionBadge } from './promise-transaction-badge';
export { AllocationWarningDialog } from './allocation-warning-dialog';
export { showAllocationSuccessToast } from './allocation-success-toast';

// Placeholder exports for routing compatibility
const PlaceholderPage = () => (
  <div className="flex items-center justify-center h-[calc(100vh-4rem)]">
    <div className="text-center space-y-4">
      <h1 className="text-4xl font-bold tracking-tight">Coming Soon</h1>
      <p className="text-muted-foreground text-lg">
        This feature is under development
      </p>
    </div>
  </div>
);

export const RecordPaymentPage = PlaceholderPage;
export const PaymentHistoryPage = PlaceholderPage;
export const UnappliedPaymentsPage = PlaceholderPage;
export const PaymentExceptionsPage = PlaceholderPage;
export const DirectDebitsPage = PlaceholderPage;
export const ReconciliationPage = PlaceholderPage;
